import { Skeleton } from "@mui/material";
import React, { useCallback } from "react";
import { useEffect } from "react";
import api from "../../../api/api";
import LoadEffect from "../../../effects/LoadEffect";
import {
  CONDITIONS,
  DEAL_TYPES,
  SCOPES,
} from "../../../utils/constants/SYSTEM";
import useAsync from "../../../utils/hooks/useAsync";
import Modal from "../../Modal/Modal";
import StackStyle from "../../Styled/Stack.style";
import CreateEditNewListPriceDealModal from "../CreateDeal/CreateEditNewListPriceDealModal";
import CreateEditNewSchemeDealModal from "../CreateDeal/CreateEditNewSchemeDealModal";
import CreateEditUsedDealModal from "../CreateDeal/CreateEditUsedDealModal";
import { useParams } from "react-router";

export default function ViewAndEditModal({ dealID, dealCondition, dealType }) {
  // Handle case where dealID and dealType are passed in from a link
  const {dealID: id, dealType: type} = useParams();
  console.log("🚀 ~ ViewAndEditModal ~ type:", type)
  console.log("🚀 ~ ViewAndEditModal ~ id:", id)
  if(id) {
    dealID = id;
  }
  if(type) {
    dealType = type;
  }

  const [
    fetchNewSchemeDealInfo,
    newSchemeDealInfoResult,
    isFetchingNewSchemeDealInfo,
  ] = useAsync(
    useCallback(() => api.getNewSchemeDealInfo(dealID), [dealID]),
    "",
    "Issue fetching new scheme deal info."
  );

  const [
    fetchNewListPriceDealInfo,
    newListPriceDealInfoResult,
    isFetchingNewListPriceDealInfo,
  ] = useAsync(
    useCallback(() => api.getNewListPriceDealInfo(dealID), [dealID]),
    "",
    "Issue fetching new list price deal info."
  );

  const [fetchUsedDealInfo, usedDealInfoResult, isFetchingUsedDealInfo] =
    useAsync(
      useCallback(() => api.getUsedDealInfo(dealID), [dealID]),
      "",
      "Issue fetching used-deal info."
    );

  useEffect(() => {
    if (
      dealCondition === CONDITIONS.NEW &&
      dealType === DEAL_TYPES.INSTALMENT_PRICE
    )
      fetchNewSchemeDealInfo(true);
    if (dealCondition === CONDITIONS.NEW && dealType === DEAL_TYPES.LIST_PRICE)
      fetchNewListPriceDealInfo(true);
    if (dealCondition === CONDITIONS.USED) fetchUsedDealInfo(true);
  }, [
    fetchNewSchemeDealInfo,
    fetchNewListPriceDealInfo,
    fetchUsedDealInfo,
    dealCondition,
    dealType,
  ]);

  return dealCondition === CONDITIONS.NEW ? (
    dealType === DEAL_TYPES.INSTALMENT_PRICE ? (
      <LoadEffect
        condition={!isFetchingNewSchemeDealInfo}
        fallback={<ModalSkeleton />}
      >
        <CreateEditNewSchemeDealModal
          scope={SCOPES.EDIT}
          dealInfo={newSchemeDealInfoResult}
        />
      </LoadEffect>
    ) : (
      dealType === DEAL_TYPES.LIST_PRICE && (
        <LoadEffect
          condition={!isFetchingNewListPriceDealInfo}
          fallback={<ModalSkeleton />}
        >
          <CreateEditNewListPriceDealModal
            scope={SCOPES.EDIT}
            dealInfo={newListPriceDealInfoResult}
          />
        </LoadEffect>
      )
    )
  ) : (
    dealCondition === CONDITIONS.USED && (
      <LoadEffect
        condition={!isFetchingUsedDealInfo}
        fallback={<ModalSkeleton />}
      >
        <CreateEditUsedDealModal
          scope={SCOPES.EDIT}
          dealCondition={CONDITIONS.USED}
          dealInfo={usedDealInfoResult}
        />
      </LoadEffect>
    )
  );
}

const ModalSkeleton = () => <Modal size={{width: "95%"}}>
  <StackStyle gap="20px">
    <Skeleton variant="rounded" width="100%" height="25px" />
    <Skeleton variant="rounded" width="100%" height="25px" />
    <Skeleton variant="rounded" width="100%" height="25px" />
    <Skeleton variant="rounded" width="100%" height="25px" />
    <Skeleton variant="rounded" width="100%" height="25px" />
    <Skeleton variant="rounded" width="100%" height="25px" />
    <Skeleton variant="rounded" width="100%" height="25px" />
    <Skeleton variant="rounded" width="100%" height="25px" />
  </StackStyle>
</Modal>